module.exports = __webpack_public_path__ + "static/img/10.23cb138.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/10.png
// module id = rhId
// module chunks = 1